export const yearsPicker = {
  recent: 'Recent',
  prievious: 'Previous',
  next: 'Next',
}
